import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, MetricDetailDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useGetMetricRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getMetricRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.metrics.getMetric>>): Promise<MetricDetailDto> {
    const accessToken = await getAccessToken();
    const [{ metricGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/metrics/${metricGuid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getMetricRequest };
};

const useGetMetric = (metricGuid: string) => {
  const { getMetricRequest } = useGetMetricRequest();

  return useQuery({
    queryKey: queryKeys.metrics.getMetric(metricGuid),
    queryFn: getMetricRequest,
  });
};

export { useGetMetric };
